/* eslint-disable  @typescript-eslint/no-explicit-any */

import React, { Component } from 'react';
import { StyleSheet, View, Animated, Easing, ViewStyle } from 'react-native';

// runAfterInteractions stucks the animation after a login. Weird.
const DELAY_BEFORE_ANIM = 200;

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (): Record<string, Record<string, string | number>> =>
  StyleSheet.create({
    background: {
      backgroundColor: 'white',
      height: 8,
    },
    fill: {
      height: 8,
    },
  });
/*eslint-enable */

interface State {
  progress: Animated.Value;
  width: number;
}

interface Props {
  backgroundStyle?: ViewStyle;
  style?: ViewStyle;
  fillStyle?: ViewStyle;
  width?: number;
  easing?: (value: number) => number;
  easingDuration?: number;
  initialProgress?: number;
  progress: number;
  fillColor: string;
}

export class ProgressBar extends Component<Props, State> {

  state = {
    width: 0,
    progress: new Animated.Value((this.props.initialProgress || 0) / 100),
  };

  styles = getStyles();

  componentDidMount(): void {
    if (this.props.progress >= 0) {
      setTimeout(this.updateProgress, DELAY_BEFORE_ANIM);
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State): void {
    if (this.props.progress >= 0 && this.props.progress !== prevProps.progress) {
      setTimeout(this.updateProgress, DELAY_BEFORE_ANIM);
    }

    if (this.state.width > 0 && this.state.width !== prevState.width) {
      setTimeout(this.updateProgress, DELAY_BEFORE_ANIM);
    }
  }

  render(): React.JSX.Element{
    const fillWidth = this.state.progress.interpolate({
      inputRange: [0, 1],
      outputRange: [0, this.state.width],
    });

    const onLayout = (event): void => {
      this.setState({ width: event.nativeEvent.layout.width });
    };

    return (
      <View style={[this.styles.background, this.props.backgroundStyle, this.props.style]} onLayout={onLayout}>
        <Animated.View
          style={[
            this.styles.fill,
            { backgroundColor: this.props.fillColor },
            this.props.fillStyle,
            { width: fillWidth },
          ]}
        />
      </View>
    );
  }

  updateProgress = (): void => {
    Animated.timing(this.state.progress, {
      easing: this.props.easing ?? Easing.ease,
      duration: this.props.easingDuration ?? 100,
      toValue: this.props.progress / 100,
      useNativeDriver: false,
    }).start();
  };
}
